import { render } from "./Tareas.vue?vue&type=template&id=f00f6ff6&scoped=true"
import script from "./Tareas.vue?vue&type=script&lang=js"
export * from "./Tareas.vue?vue&type=script&lang=js"

import "./Tareas.vue?vue&type=style&index=0&id=f00f6ff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00f6ff6"]])

export default __exports__